module.exports = __webpack_public_path__ + "img/honor-right-1-4.bc7fdae0.jpg";